import { Icon } from "@/lib/icons";

export default function SectionPlaceholder({ section, me }) {
  if (!section) return null;
  const level = (me.nav || []).find((n) => n.id === section.id)?.level;
  const fields = section.fields || [];
  const fieldPerms = (me.role && me.permissions) ? null : null;

  return (
    <div>
      <div className="flex items-center gap-3 flex-wrap mb-2">
        <div className="w-11 h-11 rounded-xl bg-ink text-cream flex items-center justify-center">
          <Icon name={section.icon} className="w-5 h-5" />
        </div>
        <h1 className="font-zilla text-3xl font-semibold">{section.label}</h1>
        {level && (
          <span className="text-[12px] uppercase tracking-wide font-bold px-2.5 py-1 rounded-full bg-olive/20 text-dark-olive border border-olive/40">
            Your access: {level}
          </span>
        )}
      </div>
      <p className="text-[17px] text-ink/70 mb-6 max-w-2xl">
        The <strong>{section.label}</strong> module is part of the Rosemoor system and will be built
        in a later phase. The shell, navigation, and your permissions for it are already in place.
      </p>

      <div className="bg-cream border border-ink/15 rounded-xl p-6">
        <h2 className="font-zilla text-xl font-semibold mb-3">What this section will hold</h2>
        {fields.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {fields.map((f) => (
              <span key={f} className="text-[14px] px-3 py-1.5 rounded-lg bg-warm-cream border border-ink/12">
                {f.replace(/_/g, " ")}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-ink/60 text-[15px]">Structure and data arrive in a later phase.</p>
        )}
      </div>
    </div>
  );
}
